import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";

export default function TenderDetailPage() {
  const { id } = useParams();
  const [tender, setTender] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [fieldValues, setFieldValues] = useState({});
  const [error, setError] = useState("");
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [newTask, setNewTask] = useState({ title: "", due_date: "" });
  const [addingTask, setAddingTask] = useState(false);
  const [newNoteText, setNewNoteText] = useState("");
 
  useEffect(() => {
    api.get(`/tenders/${id}/`)
      .then((res) => {
        setTender(res.data);
        setFieldValues(res.data);
      })
      .catch((err) => {
        console.error(err);
        setError("Ошибка загрузки тендера.");
      });
  
    api.get("/users/")
      .then((res) => setUsers(res.data))
      .catch((err) => console.error("Ошибка загрузки пользователей", err));

  }, [id]);

  const handleEditClick = (field) => {
    setEditingField(field);
  };

  const handleFieldChange = (field, value) => {
    setFieldValues(prev => ({ ...prev, [field]: value }));
  };

const handleFieldSave = async (field) => {
  try {
    let value = fieldValues[field];
    // Для сумм — удаляем пробелы и меняем , на . (на всякий случай)
    if (field === "bid_amount" || field === "cost") {
      value = value.replace(/\s/g, "").replace(",", ".");
      }
    // Преобразование поля, если это executor
    const fieldMap = {
      executor: "executor_id",
    };

    const payload = {
      [fieldMap[field] || field]: value,
    };

    const res = await api.patch(`/tenders/${id}/`, payload);
    setTender(res.data);
    setEditingField(null);
  } catch (err) {
    console.error("Ошибка обновления:", err);
    alert("Не удалось сохранить изменения.");
  }
};
  const handleDelete = async () => {
  if (!window.confirm("Удалить этот тендер?")) return;

  try {
    await api.delete(`/tenders/${id}/`);
    navigate("/");  // или navigate("/tenders") — куда должен возвращать
  } catch (err) {
    console.error("Ошибка удаления:", err);
    alert("Не удалось удалить тендер");
  }
};
  const handleCreateTask = async () => {
    if (!newTask.title.trim()) {
      alert("Введите название задачи");
      return;
    }

    try {
      await api.post(`/tenders/${id}/tasks/`, {
        ...newTask,
        tender: id,
      });
      const res = await api.get(`/tenders/${id}/`);
      setTender(res.data);
      setNewTask({ title: "", due_date: "" });
      setAddingTask(false);
    } catch (err) {
      console.error("Ошибка при добавлении задачи", err);
      alert("Не удалось создать задачу");
    }
  };
const handleCompleteTask = async (taskId) => {
  try {
    await api.patch(`/tenders/${id}/tasks/${taskId}/`, { status: "done" });
    const res = await api.get(`/tenders/${id}/`);
    setTender(res.data);
  } catch (err) {
    console.error("Ошибка при завершении задачи", err);
    alert("Не удалось завершить задачу");
  }
};

const handleDeleteTask = async (taskId) => {
  if (!window.confirm("Удалить задачу?")) return;
  try {
    await api.delete(`/tenders/${id}/tasks/${taskId}/`);
    const res = await api.get(`/tenders/${id}/`);
    setTender(res.data);
  } catch (err) {
    console.error("Ошибка при удалении задачи", err);
    alert("Не удалось удалить задачу");
  }
};

  const handleCreateNote = async (e) => {
  e.preventDefault();
  if (!newNoteText.trim()) return;
  try {
    await api.post(`/tenders/${id}/notes/`, { text: newNoteText });
    const res = await api.get(`/tenders/${id}/`);
    setTender(res.data);
    setNewNoteText("");
  } catch (err) {
    alert("Ошибка при добавлении заметки");
    console.error(err);
  }
};  
  
  if (error) return <p className="text-red-500 p-4">{error}</p>;
  if (!tender) return <p className="p-4">Загрузка...</p>;

return (
  <div className="p-6">
    <div className="flex justify-start mb-6">
      <button
        onClick={() => navigate("/")}
        className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
      >
        ⬅️ Назад
      </button>
    </div>

    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-bold">
        {tender.title} ({tender.number})
      </h1>
      <button
        onClick={handleDelete}
        className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
      >
        🗑 Удалить тендер
      </button>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Левая колонка — таблица деталей тендера */}
      <div>
        <table className="w-full table-fixed border mb-6">
          <tbody>
            <EditableRow label="Заказчик" field="customer" value={fieldValues.customer} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Номер" field="number" value={fieldValues.number} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Наименование" field="title" value={fieldValues.title} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Сумма заявки" field="bid_amount" value={fieldValues.bid_amount} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Себестоимость" field="cost" value={fieldValues.cost} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Стадия" field="stage" value={fieldValues.stage} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Контакт" field="contact" value={fieldValues.contact} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <ExecutorRow label="Исполнитель" field="executor" value={fieldValues.executor || ""} displayValue={tender.executor?.full_name || "—"} editingField={editingField} users={users} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Статус" field="status" value={fieldValues.status} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <EditableRow label="Путь к проекту" field="project_path" value={fieldValues.project_path} editingField={editingField} onEdit={handleEditClick} onChange={handleFieldChange} onSave={handleFieldSave} />
            <TableRow label="Обновлено" value={new Date(tender.updated_at).toLocaleDateString()} />
           </tbody>
        </table>
        <div className="mt-6">
            <h3 className="font-bold mb-2">Заметки</h3>
            {tender.notes && tender.notes.length > 0 ? (
              <ul>
                {tender.notes.map(note => (
                  <li key={note.id} className="border-b py-2 flex justify-between">
                    <span>{note.text}</span>
                    <span className="text-gray-400 ml-4">{new Date(note.created_at).toLocaleString()}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-400">Нет заметок</p>
            )}
          </div>
               <form
                onSubmit={handleCreateNote}
                className="flex items-end gap-2 mb-4"
              >
                <textarea
                  className="border rounded px-2 py-1 flex-1"
                  rows={2}
                  value={newNoteText}
                  onChange={e => setNewNoteText(e.target.value)}
                  placeholder="Введите заметку…"
                />
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  Добавить
                </button>
           </form> 
      </div>

      {/* Правая колонка — задачи */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Задачи</h2>
          <button onClick={() => setAddingTask(true)} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
            ➕ Добавить задачу
          </button>
        </div>

        {addingTask && (
          <div className="grid grid-cols-2 gap-4 mb-6">
            <input
              type="text"
              className="border rounded px-2 py-1"
              placeholder="Название задачи"
              value={newTask.title}
              onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
            />
            <input
              type="datetime-local"
              className="border rounded px-2 py-1"
              value={newTask.due_date}
              onChange={(e) => setNewTask({ ...newTask, due_date: e.target.value })}
            />
            <button
              onClick={handleCreateTask}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 col-span-2"
            >
              💾 Сохранить задачу
            </button>
          </div>
        )}

        {tender.tasks?.length > 0 ? (
          <table className="w-full table-fixed border-collapse">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-2 w-10">№</th>
                <th className="p-2">Название</th>
                <th className="p-2 w-32">Статус</th>
                <th className="p-2 w-40">Срок</th>
                <th className="p-2 w-32">Действия</th>
              </tr>
            </thead>
            <tbody>
              {tender.tasks.map((task, index) => (
                <tr
                  key={task.id}
                  className={`border-t hover:bg-gray-50 ${task.status === 'done' ? 'bg-green-50' : ''}`}
                >
                  <td className="p-2">{index + 1}</td>
                  <td className="p-2">{task.title}</td>
                  <td className="p-2">{task.status}</td>
                  <td className="p-2">{task.due_date ? new Date(task.due_date).toLocaleString() : "—"}</td>
                  <td className="p-2">
                    <button className="text-green-600 hover:underline mr-2" onClick={() => handleCompleteTask(task.id)} disabled={task.status === 'done'}>✅</button>
                    <button className="text-red-600 hover:underline mr-2" onClick={() => handleDeleteTask(task.id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-gray-600">Нет задач.</p>
        )}
      </div>
    </div>
  </div>
);
}

function TableRow({ label, value }) {
  return (
    <tr className="border-t">
      <td className="p-2 font-medium bg-gray-50 w-1/3">{label}</td>
      <td className="p-2">{value}</td>
    </tr>
  );
}

function EditableRow({ label, field, value, editingField, onEdit, onChange, onSave }) {
  return (
    <tr className="border-t">
      <td className="p-2 font-medium bg-gray-50 w-1/3">{label}</td>
      <td className="p-2 flex items-center gap-2">
        {editingField === field ? (
          <>
            <input
              className="border rounded px-2 py-1 w-full"
              value={value || ""}
              onChange={(e) => onChange(field, e.target.value)}
            />
            <button onClick={() => onSave(field)} className="text-green-600 hover:underline">💾</button>
          </>
        ) : (
          <>
              <span> {field === "bid_amount" || field === "cost"
                          ? value
                            ? Number(value).toLocaleString("ru-RU", {
                                style: "currency",
                                currency: "RUB",
                                minimumFractionDigits: 2
                              })
                            : "—"
                            : value || "—"}
              </span>
            <button onClick={() => onEdit(field)} className="text-blue-600 hover:underline">✏️</button>
          </>
        )}
      </td>
    </tr>
  );
}


function ExecutorRow({ label, field, value, displayValue, editingField, users, onEdit, onChange, onSave }) {
  return (
    <tr className="border-t">
      <td className="p-2 font-medium bg-gray-50 w-1/3">{label}</td>
      <td className="p-2 flex items-center gap-2">
        {editingField === field ? (
          <>
            <select
              className="border rounded px-2 py-1 w-full"
              value={value}
              onChange={(e) => onChange(field, e.target.value)}
            >
              <option value="">—</option>
              {users.map(user => (
                <option key={user.id} value={user.id}>
                  {user.full_name || user.username}
                </option>
              ))}
            </select>
            <button onClick={() => onSave(field)} className="text-green-600 hover:underline">💾</button>
          </>
        ) : (
          <>
            <span>{displayValue}</span>
            <button onClick={() => onEdit(field)} className="text-blue-600 hover:underline">✏️</button>
          </>
        )}
      </td>
    </tr>
  );
}
